module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/typography/blockquote-with-footer/blockquote-with-footer.component.scss
// module id = ./src/app/features/typography/blockquote-with-footer/blockquote-with-footer.component.scss
// module chunks = main